import React from "react";

// Neutral stat tile; accentColor is accepted for older callers but no longer changes the look.
export default function StatCard({ title, value, subtitle, icon }) {
  return (
    <section className="bg-white rounded-xl border border-line p-4 shadow-sm">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="text-meta font-medium text-muted">{title}</h3>
          <div className="mt-1 text-[28px] leading-8 font-bold text-ink tracking-tight tabular-nums">
            {value}
          </div>
          {subtitle && <p className="mt-0.5 text-[12px] text-muted">{subtitle}</p>}
        </div>
        {icon && (
          <div className="w-9 h-9 rounded-lg bg-gray-100 text-gray-600 flex items-center justify-center shrink-0">
            {icon}
          </div>
        )}
      </div>
    </section>
  );
}
